"use client";
import { useEffect } from "react";

export const useClearCache = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const version = process.env.NEXT_PUBLIC_SESSION_VERION;
    const cachedVersion = window.localStorage.getItem("session_version");
    if (cachedVersion === version) return;
    window.localStorage.setItem("session_version", version || "1");
    //clear cookies
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
  }, []);
};
